import { render, staticRenderFns } from "./RulesUse.vue?vue&type=template&id=071c205e&scoped=true&"
import script from "./RulesUse.vue?vue&type=script&lang=js&"
export * from "./RulesUse.vue?vue&type=script&lang=js&"
import style0 from "./RulesUse.vue?vue&type=style&index=0&id=071c205e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c205e",
  null
  
)

export default component.exports